//////////////////////////////
// 画面URL
//////////////////////////////
export const home_path = "/home/";
export const isummary_path = "/isummary";

// 認証
export const signin_path = "/signin";

// ユーザー
export const users_path = "/users";
export const userdetail_path = "/userdetail/";

// 通知メッセージ
export const info_path = "/info";
export const infodetail_path = "/infodetail/";
export const infoedit_path = "/infoedit/";

// アカウントグループ
export const accountgroups_path = "/accountgroups";
export const accountgroupdetail_path = "/accountgroupdetail/";
export const accountgroupedit_path = "/accountgroupedit/";

// 広告主アカウント
export const accountdetailapollo_path = "/accountdetailapollo/";
export const accounteditapollo_path = "/accounteditapollo/";

// プラットフォームアカウント
export const accountdetail_path = "/accountdetail";
export const accountdetailms_path = `${accountdetail_path}/ms/`;

// 広告主アイコン
export const adclienticonsapollo_path = "/adclienticonsapollo/";
export const adclienticoneditapollo_path = "/adclienticoneditapollo/";
export const adclienticonsapproval_path = "/adclienticonsapproval";

// 予算管理
export const budgets_path = "/budgets";
export const budget_path = "/budget";

// 確定請求金額管理
export const invoice_path = "/invoice";

// レポート管理V2
export const reports_path = "/reports";
export const reportcreate_path = "/reportcreate"
export const report_detail_path = "/reportdetail/";

// 過去分レポート管理
export const past_report_path = "/pastreport"

// マスター管理
export const masterproducts_path = "/masterproducts";
export const masterindustorys_path = "/masterindustorys";
export const masterbillingresources_path = "/masterbillingresources";

// マニュアル管理
export const manuals_path = "/manuals";

// トラッカーID移行
export const trackerIdMigration = "/trackeridmigration"

// キャンペーン
export const campaigns_path = "/campaigns/";

export const campaignedit_path = "/campaignedit/";

export const campaigneditms_path = `${campaignedit_path}ms/`;

// 広告グループ
export const adgroups_path = "/adgroups/";
export const adgroupedit_path = "/adgroupedit/";

export const adgroupsms_path = `${adgroups_path}ms/`;
export const adgroupeditms_path = `${adgroupedit_path}ms/`;

// 広告
export const advertisements_path = "/advertisements/";
export const advertisementedit_path = "/advertisementedit/";

export const advertisementsms_path = `${advertisements_path}ms/`;
export const advertisementeditms_path = `${advertisementedit_path}ms/`;

// 広告アセット
export const crassets_path = "/crassets/";
export const crassetedit_path = "/crassetedit/";

export const crassetsms_path = `${crassets_path}ms/`;
export const crasseteditms_path = `${crassetedit_path}ms/`;

// 広告アセット一括入稿
export const crassetcsvupload_path = "/crasset/csvupload/";

export const crassetcsvuploadms_path = `${crassetcsvupload_path}ms/`;

// 一括入稿
export const operations_path = "/operations/";
export const operation_platform_path = "/operation/";
export const csvupload_path = "/operation/csvupload/";

// 審査結果ダウンロード
export const review_csv_path = "/reviewcsv/";
export const review_csv_request_path = "/reviewcsvrequest/";

// Poseidon
export const segmentlistposeidon_path = "/segment/poseidon";
export const segmentdetailposeidon_path = "/segmentdetail/poseidon/";
export const customsegmentposeidon_path = "/customsegment/poseidon/";
export const geosegmentallposeidon_path = "/geosegmentall/poseidon";
export const geosegmenteditposeidon_path = "/geosegmentedit/poseidon/";
export const geosegmentposeidon_path = "/geosegment/poseidon/";
export const affinitycategorylistposeidon_path = "/affinitycategory/poseidon";
export const affinitycategoryeditposeidon_path = "/affinitycategoryedit/poseidon/";
export const userlistposeidon_path = "/userlist/poseidon";
export const userlisteditposeidon_path = "/userlistedit/poseidon/";

// Hera
export const heraaudiences_path = "/hera/audiences"
export const heraaudienceedit_path = "/hera/audience/edit/";
export const heraaudiencedetail_path = "/hera/audience/detail/";
export const herasetpoints_path = "/hera/setpoints"
export const herasetpointedit_path = "/hera/setpoint/edit/";
export const herasetpointdetail_path = "/hera/setpoint/detail/";
export const events_path = "/hera/events/"
export const audiences_path = "/hera/audiences/"
export const setpoints_path = "/hera/setpoints/"

// TODO: Apollo v2.0パス移行後に削除
export const accountdetailzeus_path = "/accountdetail/zeus/";
export const campaigndetailzeus_path = "/campaigndetailzeus/";
export const adgroupdetail_path = "/adgroupdetail/";
export const advertisementdetail_path = "/advertisementdetail/";

//////////////////////////////
// Apollo API
//////////////////////////////
export const apollo_accountgroups_path = "v2/apollo-accountgroups";
export const apollo_accountgroup_path = "v2/apollo-accountgroup";
export const apollo_approval_accountgroup_path = "v2/apollo-accountgroup-approve";
export const apollo_available_accountgroup_path = "v2/apollo-accountgroups-available";
export const apollo_billing_accountgroup_path = "v2/apollo-accountgroup-billingresource";

export const get_apollo_role_path = "v2/apollo-role";
export const get_apollo_roles_path = "v2/apollo-roles";
export const get_apollo_roles_by_accountgroup_path = "v2/apollo-roles/accountgroup";

export const apollo_account_path = "v2/apollo-account";
export const apollo_accounts_path = "v2/apollo-accounts";
export const apollo_account_platform_path = "v2/apollo-account-platform";

export const apollo_account_platform_menu_path = "v2/apollo-account-platform-menu";
export const apollo_account_platform_menu_all_path = "v2/apollo-account-platform-menu-all";
export const apollo_account_accountgroup_path = "v2/apollo-account-detail";
export const apollo_account_approval_path = "v2/apollo-account-approval";
export const apollo_account_performances = "v2/apollo-account-performances"
export const apollo_account_performances_graph = "v2/apollo-account-performances-graph"
export const apollo_account_campaign_path = "v2/apollo-account-campaign";
export const apollo_accounts_trackerid_migration_source_path = "v2/apollo-accounts-trackerid_migration";
export const apollo_accounts_trackerid_migration_active_path = "v2/apollo-trackerid-migration-active-account";

export const apollo_platform_account20_path = "v2/apollo-platform-account"

export const apollo_ad_client_icon_path = "v2/apollo-ad-client-icon";
export const apollo_ad_client_icons_path = "v2/apollo-ad-client-icons";
export const apollo_ad_client_icon_approval_path = "v2/apollo-ad-client-icon-approval";
export const apollo_ad_client_icons_approval_path = "v2/apollo-ad-client-icons-approval";

// マスター管理
export const apollo_menu_master_path = "v2/apollo-master/menu"
export const apollo_billing_resources_path = "v2/apollo-master/billingresources";
export const apollo_billing_resource_path = "v2/apollo-master/billingresource";
export const apollo_billing_resource_master_relation_path = "v2/apollo-master/billingresources/relation"
export const apollo_billing_resource_master_accountgroups_path = "v2/apollo-master/billingresource/accountgroups"
export const apollo_menu_campaign_master_path = "v2/apollo-master/menu/campaign"
export const apollo_industorycategory_master_path = "v2/apollo-master/industorycategory"
export const apollo_industory_master_path = "v2/apollo-master/industory"
export const apollo_industory_master_relation_path = "v2/apollo-master/industory/relation"
export const apollo_industory_master_products_path = "v2/apollo-master/industory/products"
export const apollo_product_master_path = "v2/apollo-master/product"
export const apollo_product_master_relation_path = "v2/apollo-master/product/relation"
export const apollo_product_master_accouts_path = "v2/apollo-master/product/accounts"
export const apollo_budgetno_master_path = "v2/apollo-master/budgetno"

// マニュアル管理
export const apollo_manuals_path = "v2/apollo-manuals";

export const apollo_users_path = "v2/apollo-users/";
export const apollo_user_path = "v2/apollo-user/";
export const apollo_users_accountgroup_path = "v2/apollo-users/accountgroup/";
export const apollo_user_download_path = "/v2/apollo-user-download/";
export const apollo_user_option_path = "v2/apollo-user-option/";
export const apollo_user_role_path = "v2/apollo-user-role";

export const apollo_info_path = "v2/apollo-notify/";
export const apollo_relation_info_path = "v2/apollo-relation-notify";
export const apollo_message_history_path = "v2/apollo-message-history/";

export const apollo_campaign_performances = "v2/apollo-campaign-performances"
export const apollo_account_budget_cost_performances = "v2/apollo-account-budget-cost-performances"

// 確定請求金額管理
export const apollo_billing_reports = "v2/apollo-billing-reports"
export const apollo_billing_report = "v2/apollo-billing-report"
export const apollo_billing_prices = "v2/apollo-billing-prices"

// 予算管理
export const apollo_budgets_path = "v2/apollo-budgets"
export const apollo_budget_path = "v2/apollo-budget"
export const apollo_budget_menu_path = "v2/apollo-menu-budget"
export const apollo_menu_budget_check_path = "v2/apollo-menu-budget-check"
//Zeus RTB
export const apollo_zeus_delivery_type_budgets_path = "v2/apollo-zeus-delivery-type-budgets"

// レポート
export const apollo_report_path = "v2/apollo-report2"
export const apollo_reports_path = "v2/apollo-reports2"
export const apollo_report_setting_path = "v2/apollo-report2-setting"
export const apollo_report_settings_path = "v2/apollo-report2-settings"
export const apollo_report_rerun_path = "v2/apollo-report2-rerun"
export const apollo_report_download_path = "v2/apollo-report2-download"
export const apollo_report_campaign_names_path = "v2/apollo-report2-campaignnames"
export const apollo_report_output_columns_master_path = "v2/apollo-report2-outputcolumns-master"

// 過去分レポート
export const apollo_past_report_path = "v2/apollo-past-reports"
export const apollo_past_report_download_path = "v2/apollo-past-report-download"

// 測定ポイント管理
export const apollo_setpoints_path = "v2/apollo-setpoints"

// 実績管理
export const apollo_budget_cost_performances_path = "v2/apollo-account-budget-cost-performances"

// 操作履歴
export const apollo_operation_log = "v2/apollo-operation-log-operator";
export const apollo_operation_history_account_names = "v2/apollo-operation-log/adaccountnames";
export const apollo_operation_history_campagine_names = "v2/apollo-operation-log/campaignnames";
export const apollo_operation_history_adgroup_names= "v2/apollo-operation-log/adgroupnames";

// Zeus Proxy
export const get_zeus_campaign_path = "zeusproxy/api/v2/ad-campaigns"
export const post_zeus_campaign_path = "zeusproxy/api/v2/ad-campaigns"
export const patch_zeus_campaign_path = "zeusproxy/api/v2/ad-campaigns"
export const get_zeus_ad_group_path = "zeusproxy/api/v2/ad-groups"
export const patch_zeus_ad_group_path = "zeusproxy/api/v2/ad-groups"
export const get_zeus_ad_group_performance_path = "zeusproxy/api/v2/ad-groups_performance"
export const zeus_ad_account = "zeusproxy/api/v2/ad-accounts/"
export const get_zeus_ads = "zeusproxy/api/v2/ads"
export const patch_zeus_ads_path = "zeusproxy/api/v2/ads"
export const get_zeus_ads_performance_path = "zeusproxy/api/v2/ads_performance"
export const get_zeus_resources_images_path = "zeusproxy/api/v2/ad-resources/images"
export const post_zeus_resources_path = "zeusproxy/api/v2/ad-resources"
export const get_zeus_resources_path = "zeusproxy/api/v2/ad-resources"
export const post_zeus_draft_csv_upload_path = "zeusproxy/api/v2/draft-csv/upload"
export const get_zeus_draft_csv_download_path = "zeusproxy/api/v2/draft-csv/download"
export const get_zeus_draft_csv_upload_results_path = "zeusproxy/api/v2/draft-csv/upload-results"
export const get_zeus_placement_settings_path = "zeusproxy/api/v2/placement-settings"
export const get_zeus_placement_settings = "zeusproxy/api/v2/placement-settings"
export const get_zeus_resources_tags_path = "zeusproxy/api/v2/ad-resources/tags"

export const get_zeus_review_csv_path = "zeusproxy/api/v2/review-csv"
export const post_zeus_review_csv_path = "zeusproxy/api/v2/review-csv"

// Poseidon Proxy
export const poseidon_segment_path = "poseidonproxy/api/v2/segment";
export const list_poseidon_segments_path = "poseidonproxy/api/v2/list/segments";
export const estimate_poseidon_segment_path = "poseidonproxy/api/v2/estimate/segment";
export const upload_poseidon_file_path = "poseidonproxy/api/v2/upload-file";

export const list_poseidon_affinitycategory_path = "poseidonproxy/api/v2/list/affinitycategories";
export const get_poseidon_affinitycategory_path = "poseidonproxy/api/v2/affinitycategory/";
export const create_poseidon_affinitycategory_path = "poseidonproxy/api/v2/create/affinitycategory";
export const update_poseidon_affinitycategory_path = "poseidonproxy/api/v2/update/affinitycategory";
export const delete_poseidon_affinitycategory_path = "poseidonproxy/api/v2/delete/affinitycategory";

export const list_poseidon_userlist_path = "poseidonproxy/api/v2/list/userlists";
export const get_poseidon_userlist_path = "poseidonproxy/api/v2/userlist/";
export const create_poseidon_userlist_path = "poseidonproxy/api/v2/create/userlist";
export const update_poseidon_userlist_path = "poseidonproxy/api/v2/update/userlist";
export const delete_poseidon_userlist_path = "poseidonproxy/api/v2/delete/userlist";

export const poseidon_geosegment_path = "poseidonproxy/api/v2/geosegment";
export const list_poseidon_geosegments_path = "poseidonproxy/api/v2/list/geosegments";
export const create_poseidon_geosegment_path = "poseidonproxy/api/v2/create/geosegment";
export const update_poseidon_geosegment_path = "poseidonproxy/api/v2/update/geosegment";
export const delete_poseidon_geosegment_path = "poseidonproxy/api/v2/delete/geosegment";

export const list_poseidon_availabletarget_path = "poseidonproxy/api/v2/list/availabletarget/";
export const list_poseidon_availableaffinity_path = "poseidonproxy/api/v2/list/availableaffinity/";
export const list_poseidon_availablegeosegments_path = "poseidonproxy/api/v2/list/available-geosegments/";

export const get_poseidon_condition_path = "poseidonproxy/api/v2/condition";

// MS Proxy
export const get_ms_account_path = "msproxy/api/v2/ad-account"
export const post_ms_accounts_upd_path = "msproxy/api/v2/ad-accounts/upd"

export const get_ms_campaignNames_path = "msproxy/api/v2/ad-campaignNames"
export const get_ms_campaigns_path = "msproxy/api/v2/ad-campaigns"
export const get_ms_campaign_path = "msproxy/api/v2/ad-campaign"
export const post_ms_campaign_path = "msproxy/api/v2/ad-campaign"
export const put_ms_campaign_path = "msproxy/api/v2/ad-campaign"

export const get_ms_advertisements_withperform_path = "msproxy/api/v2/advertisements-withPerform"
export const get_ms_advertisements_path = "msproxy/api/v2/advertisements"
export const get_ms_advertisement_path = "msproxy/api/v2/advertisement"
export const post_ms_advertisement_path = "msproxy/api/v2/advertisement"
export const put_ms_advertisement_path = "msproxy/api/v2/advertisement"

export const get_ms_adgroups_withperform_path = "msproxy/api/v2/ad-groups-withPerform"
export const get_ms_adgroups_path = "msproxy/api/v2/ad-groups"
export const get_ms_adgroup_path = "msproxy/api/v2/ad-group"
export const post_ms_adgroup_path = "msproxy/api/v2/ad-group"
export const put_ms_adgroup_path = "msproxy/api/v2/ad-group"

export const get_ms_assets_path = "msproxy/api/v2/ad-assets"
export const get_ms_asset_path = "msproxy/api/v2/ad-asset"
export const post_ms_asset_path = "msproxy/api/v2/ad-asset"
export const put_ms_asset_path = "msproxy/api/v2/ad-asset"

export const post_ms_batch_path = "msproxy/api/v2/ad-batch"
export const get_ms_batch_path = "msproxy/api/v2/ad-batch"
export const get_ms_batch_download_path = "msproxy/api/v2/ad-batch/download"

export const post_ms_ad_asset_batch_path = "msproxy/api/v2/ad-asset-batch"
export const get_ms_ad_asset_batch_path = "msproxy/api/v2/ad-asset-batch"
export const get_ms_ad_asset_batch_download_path = "msproxy/api/v2/ad-asset-batch/download"


// Hera Proxy
export const hera_audiences_path = "heraproxy/api/v2/audiences"
export const hera_setpoints_path = "heraproxy/api/v2/setpoints"
export const hera_events_path = "heraproxy/api/v2/events"
export const hera_tracker_path = "heraproxy/api/v2/trackers"
export const hera_account_path = "heraproxy/api/v2/accounts"

// aloha & auth
export const signin_api = "v2/apollo-signin";
export const resignin_api = "v2/apollo-resignin";
export const signout_api = "v2/apollo-signout";
export const refresh_api = "v2/apollo-refresh";

// トラッカーID移行
export const put_tracker_id_migration_path = "v2/apollo-tracker-id-migration";

